import Head from 'next/head';
import {useRouter} from 'next/router';
import {useTranslation} from 'next-i18next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';

import SearchLayout from '@/src/Search/components/SearchLayout';

import {PREVIEW_IMAGE_PATH} from '../job-portal/position/[slug]';

const SearchPage = ({host}) => {
  const {t} = useTranslation('metaData');
  const {asPath, query} = useRouter();

  const fullPath = `https://${host}${asPath}`;
  const imagesPath = `https://${host}/${PREVIEW_IMAGE_PATH}`;

  const pageData = `${query.slug}Search`;

  const metaTitle = t(`${pageData}.title`);
  const metaDescription = t(`${pageData}.description`);

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/*Open Graph / Facebook*/}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={fullPath} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={imagesPath} />

        {/*Twitter*/}
        <meta name="twitter:site" content={host} />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={imagesPath} />
      </Head>
      <SearchLayout />
    </>
  );
};

export async function getServerSideProps({locale, ...context}) {
  return {
    props: {
      host: context.req.headers.host,
      ...(await serverSideTranslations(locale, [
        'common',
        'service',
        'doctors',
        'metaData',
      ])),
    },
  };
}

export default SearchPage;
